import Parse from "parse";

export function optimizeImage(file) {
    return new Promise((resolve, reject) => {
        if (window.FileReader) {
            // great success! All the File APIs are supported.
            let reader = new FileReader();

            reader.onloadstart = e => {};

            reader.onloadend = e => {
                let error = e.target.error;
                if (error != null) {
                    switch (error.code) {
                        case error.ENCODING_ERR:
                            reject("encoding error");
                            break;

                        case error.NOT_FOUND_ERR:
                            reject("not found error");
                            break;

                        case error.NOT_READABLE_ERR:
                            reject("not readable error");
                            break;

                        case error.SECURITY_ERR:
                            reject("security error");
                            break;

                        default:
                            reject("generic error");
                            break;
                    }
                } else {
                    // starting the image optmization process
                    let image = new Image();
                    image.onload = imageEvent => {
                        // Resize the image
                        let canvas = document.createElement("canvas"),
                            max_size = 550,
                            width = image.width,
                            height = image.height;
                        if (width > height) {
                            if (width > max_size) {
                                height *= max_size / width;
                                width = max_size;
                            }
                        } else {
                            if (height > max_size) {
                                width *= max_size / height;
                                height = max_size;
                            }
                        }
                        canvas.width = width;
                        canvas.height = height;
                        canvas
                            .getContext("2d")
                            .drawImage(image, 0, 0, width, height);
                        // this is the base64 img
                        let base64 = canvas.toDataURL("image/jpeg");
                        resolve(base64);
                    };
                    image.src = e.target.result;
                }
            };
            // read in the image file as a data URL.
            reader.readAsDataURL(file);
        } else reject("The File API are not fully supported in this browser.");
    });
}

export function uploadImage(fileName, base64) {
    return new Promise((resolve, reject) => {
        // creating the parse file
        let parseFile = new Parse.File(fileName, { base64: base64 });
        // uploading the parse file
        parseFile.save().then(
            result => {
                // resolve the promise and get the image url
                resolve(result._url);
            },
            err => {
                // reject the promise
                reject(err);
            }
        );
    });
}

export const getBase64 = (file) => {
    return new Promise(resolve => {
        let fileInfo;
        let baseURL = "";
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve({ fileName: file.name, base64: baseURL });
        };
    });
};